export const THEME_COLOR = {
    // blue
    BLUE_01: '#09BAD5',
    BLUE_02: '#53B7D2',
    BLUE_03: '#00a3e0',
    // light grey
    LIGHT_GREY_01: '#f5f5f5',
    LIGHT_GREY_02: '#bdbdbd',
    // grey
    GREY_00: '#dfdfdf',
    GREY_01: '#ccc',
    GREY_02: '#95989f',
    GREY_03: '#727479',
    GREY_04: '#666666',
    GREY_05: '#4d4d4f',
    // black
    BLACK_05: '#212121',
    //white
    WHITE_01: '#fff',
    // yellow, warning
    WARNING_01: '#f59c00',
    // pink
    PINK_01: '#E54179',
    PINK_02: '#f03c78',
    PINK_03: '#ef3a7a',
    PINK_04: '#f45087',
    PINK_05: '#e52565',
};
